var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMessageReadIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-3326533834__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.932 8.413a.75.75 0 1 0-1.127-.99l-6.648 7.562-3.922-3.965a.75.75 0 1 0-1.067 1.055l4.488 4.537a.75.75 0 0 0 1.096-.032zm4.93 0a.75.75 0 0 0-1.127-.99l-7.18 8.166a.75.75 0 0 0 1.127.99z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-3326533834__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageReadIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };